module.exports = __webpack_public_path__ + "static/media/scroll3_5_1.e5f5a5c4.png";